module.exports = __webpack_public_path__ + "static/img/Basil-Hart.866a64d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Basil-Hart.jpg
// module id = Je+o
// module chunks = 0